import { render, staticRenderFns } from "./cerrar.vue?vue&type=template&id=2749f212&"
import script from "./cerrar.vue?vue&type=script&lang=js&"
export * from "./cerrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports